import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded bg-panel-2", className)} aria-hidden />;
}

export function EmptyState({ icon, title, description, action, className }: { icon?: ReactNode; title: string; description?: ReactNode; action?: ReactNode; className?: string }) {
  return (
    <div className={cn("flex flex-col items-center justify-center rounded-lg border border-dashed border-border px-6 py-12 text-center", className)}>
      {icon && <div className="mb-3 text-fg-3" aria-hidden>{icon}</div>}
      <h3 className="text-sm font-semibold text-fg">{title}</h3>
      {description && <p className="mt-1 max-w-md text-sm text-fg-2">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function ErrorNote({ error, className }: { error: unknown; className?: string }) {
  if (!error) return null;
  const e = error as { message?: string; requestId?: string | null; code?: string };
  return (
    <div role="alert" className={cn("rounded-md border border-critical/40 bg-critical/10 px-3 py-2 text-sm text-[#ffaaaa]", className)}>
      {e.message ?? "Something went wrong."}
      {e.requestId && <span className="ml-2 font-mono text-xs text-fg-3">request {e.requestId}</span>}
    </div>
  );
}
